module.exports = _.assign;


//////////////////
// WEBPACK FOOTER
// external "_.assign"
// module id = 572
// module chunks = business-manager/video-library-page full-screen-modals/full-screen-modals mobile-overlay/mobile-overlay mobile/mobile widget/widget dashboard/dashboard app-settings/app-settings